export default "__VITE_ASSET__f6f879b6__"